import {usePage} from "@inertiajs/vue3";
import Bugsnag from "@bugsnag/js";

export function trackEvent(event, data) {
    if (typeof LTIAnalytics !== 'undefined') {
        const {props} = usePage()

        LTIAnalytics.init(props.lti_analytics.api_key, {
            endpoint: props.lti_analytics.api_url + '/api/v1',
            debug: true,
            autoTrack: true
        });

        if (props?.auth?.user?.id) {
            LTIAnalytics.identify(props.auth.user.id, {
                user_id: props.auth.user.id
            });
        }

        if (data) {
            LTIAnalytics.track(event, data);
        } else {
            LTIAnalytics.track(event);
        }

        console.log(`++ LTI Analytics: Tracked ${event}`);
    } else {
        console.error(`++ LTI Analytics: Failed to track event ${event}. LTIAnalytics is not defined`);
        Bugsnag.notify(new Error('LTI Analytics is not defined'), function (bugsnagEvent) {
            bugsnagEvent.severity = 'warning';
            if (data) {
                bugsnagEvent.addMetadata('eventData', data);
            }
        })
    }
}

let lastBounceEventKey = '';
let lastBounceEventAt = 0;

export function trackStarShopBounceEvent(event, data = {}) {
    const bounceKey = `${event}|${data.source ?? ''}|${data.product_id ?? ''}`;
    if (bounceKey === lastBounceEventKey && Date.now() - lastBounceEventAt < 1000) return;
    lastBounceEventKey = bounceKey;
    lastBounceEventAt = Date.now();
    fetch(route('members2.shop.bounce-event'), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.content ?? '',
        },
        body: JSON.stringify({event, ...data}),
    }).then(res => {
        if (!res.ok) { res.json().then(body => console.warn('Bounce event rejected:', event, body)).catch(() => {}); }
    }).catch(() => {});
}

export function getFathomPostPrefix(routePrefix) {
    return routePrefix === 'members2' ? 'Member_Post' : 'Tour_Post'
}

export function trackFathomEvent(event) {
    if (typeof fathom !== 'undefined' ) {
        fathom.trackEvent(event);
    } else {
        console.error(`++ Fathom: Failed to track event ${event}. Fathom is not defined`);
        Bugsnag.notify(new Error('Fathom is not defined'), function (bugsnagEvent) {
            bugsnagEvent.severity = 'warning';
        })
    }
}

export function getFathomPagePrefix(routePrefix) {
    return routePrefix === 'members2' ? 'Member' : 'Tour';
}

export function trackFeatureEvent(event, featureSlug) {
    if (typeof nanalytics !== 'undefined') {
        nanalytics.trackExperiment(event, featureSlug);
    }
}
